var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.469 8.283 4.75 12.85H7.6v5.7h3.8v-5.7h2.85L9.469 8.283ZM17.1 1.45H1.9c-1.045 0-1.9.855-1.9 1.9v11.4c0 1.045.855 1.9 1.9 1.9h3.8v-1.9H1.9V6.2h15.2v8.55h-3.8v1.9h3.8c1.045 0 1.9-.855 1.9-1.9V3.35c0-1.045-.855-1.9-1.9-1.9ZM2.375 4.537a.713.713 0 1 1 0-1.425.713.713 0 0 1 0 1.425Zm1.9 0a.713.713 0 1 1 0-1.425.713.713 0 0 1 0 1.425ZM17.1 4.3H5.7v-.95h11.418l-.018.95Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/Publish.d42ca6ca2e93312e966ea90d56840eb0.svg";
export { ForwardRef as ReactComponent };